import { useChatStore, useMessages } from "@/runtime/chatStore";
import { EmptyState } from "./EmptyState";
import { Message } from "./Message";

export function Thread() {
  const messages = useMessages();
  const isStreaming = useChatStore((s) => s.isStreaming);
  if (messages.length === 0) return <EmptyState />;

  return (
    <div className="mx-auto flex w-full max-w-[var(--reading-measure)] flex-col gap-[var(--space-8)] px-[var(--space-4)] py-[var(--space-10)]">
      {messages.map((m, idx) => {
        const isLastAssistant = idx === messages.length - 1 && m.role === "assistant" && isStreaming;
        return <Message key={m.id} message={m} isStreaming={isLastAssistant} />;
      })}
    </div>
  );
}
